import styled from "styled-components";
import { Text } from "../../../config/Constants";
import ListWithPagination from "../../ListsWithPagination";
import { useNavigate } from "react-router-dom";
import { titleCase } from "../../../helper";
import { TableWithPagination } from "../../TableWithPagination";

interface Props {
  isTableDataLoading: boolean;
  data: {
    id: string;
    name: string;
    phone: string;
    parkingSpot: string;
    loam: string;
    package: string;
    startDate: string;
    expiryDate: string;
    status: string;
    additionalService: boolean;
  }[];
  totalData: number;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
}

const YachtRegistrationHistoryTable = ({
  isTableDataLoading,
  data,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const navigate = useNavigate();
  const getLinkText = (linkText: string, id: string) => (
    <StyledLinkText
      onClick={() => {
        navigate(`/admin/view-details/${id}`);
      }}
    >
      {linkText}
    </StyledLinkText>
  );

  const columns = [
    {
      path: "name",
      label: "Name",
      content: (data: { name: string }) => <div>{titleCase(data.name)}</div>,
    },
    {
      path: "phone",
      label: "Contact",
    },
    {
      path: "parkingSpot",
      label: "Berth Number",
      content: (data: { parkingSpot: string; status: string }) => (
        <div>
          {data.status === "rejected" ? "-" : titleCase(data?.parkingSpot)}
        </div>
      ),
    },
    {
      path: "package",
      label: "Package",
      content: (data: { package: string }) => (
        <div>
          {data.package === "dropOrPickUp"
            ? "DropOff/PickUp"
            : titleCase(data.package)}
        </div>
      ),
    },
    {
      path: "additionalService",
      label: "Additional Services",
      content: (data: { additionalService: boolean }) => (
        <div>{data.additionalService === true ? "Yes" : "No"}</div>
      ),
    },
    {
      path: "status",
      label: "Registration Status",
      content: (data: { status: string }) => (
        <div>{titleCase(data.status)}</div>
      ),
    },
    {
      path: "paymentStatus",
      label: "Payment Status",
      content: (data: { status: string; paymentStatus: string }) => (
        <div>
          {data.status === "rejected"
            ? "Completed"
            : titleCase(data.paymentStatus)}
        </div>
      ),
    },
    {
      path: "registrationDetail",
      label: "Registration Detail",
      content: (data: { id: string }) => getLinkText("View Detail", data.id),
    },
  ];

  return (
    <>
      <TableWrapper>
        <TableWithPagination
          isTableDataLoading={isTableDataLoading}
          columns={columns}
          data={data}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={Text.yachtRegistrationHistoryDetails}
          hidePagination={false}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledLinkText = styled.button`
  background: transparent;
  border: none;
  color: #2ca5ff;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Poppins-Medium";
  font-weight: 500;
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default YachtRegistrationHistoryTable;
